export enum CreditCardType {
    Unknown = 0,
    Visa = 1,
    MasterCard = 2,
    AmericanExpress = 3
}
